/* eslint function-paren-newline: ["error", "consistent"] */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Spin, Form, Input, Select, Button, message, Radio } from 'antd';
import validationRegex from '../utils/validationRegex';

import getAllCustomerAddressTypesQuery from '../graphql/queries/getAllCustomerAddressTypesQuery.graphql';
import STORE_QUERY from '../graphql/queries/getCustomerAddressesQuery.graphql';
import MUTATION from '../graphql/mutations/storeCustomerAddressMutation.graphql';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option } = Select;
const { TextArea } = Input;

const labelColXsSpan = 4;
const formItemLayout = {
  labelCol: {
    xs: { span: labelColXsSpan },
  },
  wrapperCol: {
    xs: { span: 6 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: labelColXsSpan,
    },
  },
};

class CustomerAddressForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, { address, ...values }) => {
      const { customer_id } = this.props;
      if (!err) {
        this.props.mutate({
          variables: { customer_id, ...values, address: address.replace(/\r?\n|\r/g, ' ') },
          update: (cache, { data: { customerAddress } }) => {
            const data = cache.readQuery({
              query: STORE_QUERY,
              variables: { customer_id },
            });
            if (!Array.isArray(data.customerAddresses)) data.customerAddresses = [];
            data.customerAddresses.push(customerAddress);
            cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { addressTypes, loading } = this.props.getAllCustomerAddressTypesQuery;

    if (loading) {
      return (
        <Spin />
      );
    }
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          hasFeedback
          label="Type"
          style={{ width: 150 }}
        >
          {
            getFieldDecorator(
              'type_id',
              {
                rules: [
                  {
                    required: true,
                    message: 'Type is required!',
                  },
                ],
              },
            )(<Select>{addressTypes.map((type) => (<Option key={type.id} value={type.id}>{type.name}</Option>))}</Select>)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Street address"
        >
          {
            getFieldDecorator(
              'address',
              {
                rules: [
                  {
                    required: true,
                    message: 'Street address is required!',
                  },
                ],
              },
            )(<TextArea rows={4} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="City"
        >
          {
            getFieldDecorator(
              'city',
              {
                rules: [
                  {
                    required: true,
                    message: 'City is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="State"
        >
          {
            getFieldDecorator(
              'state',
              {
                rules: [
                  {
                    required: true,
                    message: 'City is required!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Pincode"
        >
          {
            getFieldDecorator(
              'pincode',
              {
                rules: [
                  {
                    required: true,
                    message: 'City is required!',
                  },
                  {
                    pattern: validationRegex.pincode,
                    message: 'Pincode incorrect!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          label="Address Proof"
          className="form-item-block"
        >
          {
            getFieldDecorator(
              'address_proof',
              {
                rules: [
                  {
                    required: true,
                    message: 'Select one entry',
                  },
                ],
              },
            )(
              <RadioGroup>
                <Radio value="electricity">Electricity bill</Radio>
                <Radio value="phone">Phone bill</Radio>
                <Radio value="both">Both</Radio>
                <Radio value="none">Address proof not required</Radio>
              </RadioGroup>,
            )
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" htmlType="submit" size="small" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

CustomerAddressForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
  getAllCustomerAddressTypesQuery: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    addressTypes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  }).isRequired,
};

export default compose(
  graphql(getAllCustomerAddressTypesQuery, { name: 'getAllCustomerAddressTypesQuery' }),
  graphql(MUTATION),
  Form.create(),
)(CustomerAddressForm);



// WEBPACK FOOTER //
// ./src/forms/CustomerAddressForm.jsx